import axios from 'axios'
import { AppUrl } from '@/assets/js/variables'

const state = {
  productExcel: {
    availability: null,
    items: []
  },
  sellersExcel: {
    availability: null,
    items: []
  },
  productLoading: false,
  sellerLoading: false,
  priceTracking: {
    categories: [
      { id: 0, name: 'All' }
    ],
    brands: [
      { id: 0, name: 'All' }
    ]
  },
  priceRules: {
    loading: false,
    noData: false,
    items: []
  },
  sellers: {
    loading: false,
    noData: false,
    items: []
  },
  trackingSellers: {
    items: [
      {
        id: 0,
        name: 'Cheapest'
      }
    ]
  }
}

const getters = {

}

const actions = {
  getExcel ({ commit }, filter) {
    if (filter.reportType === 1) {
      commit('SET_update_product_loading', true)
    } else if (filter.reportType === 2) {
      commit('SET_update_seller_loading', true)
    }
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'reportSettings',
        payload: {
          report_type: filter.reportType
        }
      })
        .then(response => {
          console.log('response.data.payload', response.data.payload)
          if (response.data.payload.rules) {
            if (response.data.payload.report_type === 1) {
              commit('SET_productExcel', response.data.payload)
              commit('SET_update_product_loading', false)
              resolve()
            } else if (response.data.payload.report_type === 2) {
              commit('SET_sellersExcel', response.data.payload)
              commit('SET_update_seller_loading', false)
              resolve()
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  updateExcelOption ({ commit }, filter) {
    commit('SET_ExcelOption', filter)
    console.log('filter', filter)
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'saveReportSettings',
        payload: {
          field_name: filter.fieldName,
          field_value: filter.fieldValue,
          report_type: filter.reportType
        }
      })
        .then(response => {
          if (response.data.payload) {
            resolve()
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getCategories ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getCategory',
        payload: {
          category_name: filter.categoryName,
          brand_id: filter.brandId,
          page_id: filter.pageId
        }
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_priceTrackingCategories', response.data.payload.category)
          }
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getBrands ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getBrand',
        payload: {
          brand_name: filter.brandName,
          category_id: filter.categoryId,
          page_id: filter.pageId
        }
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_priceTrackingBrands', response.data.payload.brand)
          }
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  savePriceRule ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'savePriceRule',
        payload: {
          category_id: filter.categoryId,
          brand_id: filter.brandId,
          price_value: filter.priceValue,
          rule_id: filter.ruleId
        }
      })
        .then(response => {
          if (response.data.payload) {
            resolve()
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getPriceOptions ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'reportSettings',
        payload: {
          rules: {
            show_delta: 1,
            show_delta_percentage: 1,
            show_availability: 1,
            show_price_suggestion: 1,
            show_category_tree: 1,
            show_product_variation: 1,
            show_seller: 1
          },
          report_type: 1
        }
      })
        .then(response => {
          if (response.data.payload) {
            // commit('SET_productRules', response.data.payload.rules)
          }
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getPriceRules ({ commit }, filter) {
    commit('SET_loading_priceRules', true)
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'priceRules',
        payload: {}
      })
        .then(response => {
          if (response.data.payload.rules) {
            commit('SET_priceRules', response.data.payload.rules)
            commit('SET_loading_priceRules', false)
            commit('SET_noData_priceRules', false)
            resolve()
          } else {
            commit('SET_loading_priceRules', false)
            commit('SET_noData_priceRules', true)
            resolve()
          }
        })
        .catch(error => {
          commit('SET_loading_priceRules', false)
          commit('SET_noData_priceRules', true)
          resolve()
          console.log(error)
        })
    })
  },
  saveReportPriceRulesOrder ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'saveReportPriceRulesOrder',
        payload: {
          rules_order: filter.orderIds
        }
      })
        .then(response => {
          if (response.data.payload) {
            resolve()
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  deleteProduct ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'deletePriceRule',
        payload: {
          ruleIds: [filter.ruleId]
        }
      })
        .then(response => {
          resolve()
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  getSellers ({ commit }, filter) {
    commit('SET_loading_sellers', true)
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'reportSellers',
        payload: {}
      })
        .then(response => {
          if (response.data.payload.sellers && response.data.payload.sellers.length > 0) {
            commit('SET_sellers', response.data.payload.sellers)
            commit('SET_loading_sellers', false)
            commit('SET_noData_sellers', false)
            resolve()
          } else {
            commit('SET_loading_sellers', false)
            commit('SET_noData_sellers', true)
            resolve()
          }
        })
        .catch(error => {
          commit('SET_loading_sellers', false)
          commit('SET_noData_sellers', true)
          resolve()
          console.log(error)
        })
    })
  },
  getSellerTracking ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getSeller',
        payload: {
          seller_name: filter.sellerName,
          page_id: filter.pageId
        }
      })
        .then(response => {
          console.log(response.data.payload.seller)
          if (response.data.payload.seller) {
            commit('SET_trackingSellers', response.data.payload.seller)
            resolve()
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  saveSellers ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'saveReportSellers',
        payload: {
          sellers: filter.sellers
        }
      })
        .then(response => {
          if (response.data.payload.sellers) {
            resolve()
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  }
}

const mutations = {
  SET_productExcel (state, data) {
    Object.keys(data.rules).forEach(key => {
      if (key !== 'show_category_tree' && key !== 'show_seller') {
        Number(data.rules[key]) === 0 ? data.rules[key] = false : data.rules[key] = true
      }
    })
    state.productExcel.availability = data.available
    state.productExcel.items = data.rules
  },
  SET_update_product_loading (state, bool) {
    state.productLoading = bool
  },
  SET_update_seller_loading (state, bool) {
    state.sellerLoading = bool
  },
  SET_ExcelOption (state, data) {
    if (data.reportType === 1) {
      state.productExcel.items[data.fieldName] = data.fieldValue !== '0'
    }
    if (data.reportType === 2) {
      state.sellersExcel.items[data.fieldName] = data.fieldValue !== '0'
    }
  },
  SET_sellersExcel (state, data) {
    Object.keys(data.rules).forEach(key => {
      if (key !== 'show_category_tree' && key !== 'show_seller') {
        Number(data.rules[key]) === 0 ? data.rules[key] = false : data.rules[key] = true
      }
    })
    state.sellersExcel.availability = data.available
    state.sellersExcel.items = data.rules
  },
  SET_priceTrackingCategories (state, data) {
    state.priceTracking.categories.unshift({ id: 0, name: 'All' })
    state.priceTracking.categories = data
  },
  SET_priceTrackingBrands (state, data) {
    state.priceTracking.brands.unshift({ id: 0, name: 'All' })
    state.priceTracking.brands = data
  },
  SET_priceRules (state, data) {
    state.priceRules.items = data
  },
  SET_mutatePriceRules (state, filter) {
    const movedItem = state.priceRules.items.splice(filter.oldIndex, 1)[0]
    state.priceRules.items.splice(filter.newIndex, 0, movedItem)
    state.priceRules.items.forEach((el, index) => {
      el.order = index + 1
    })
  },
  SET_loading_priceRules (state, bool) {
    state.priceRules.loading = bool
  },
  SET_noData_priceRules (state, bool) {
    state.priceRules.noData = bool
  },
  SET_sellers (state, data) {
    state.sellers.items = data
  },
  SET_sellerEnabled (state, data) {
    const elemIndex = state.sellers.items.findIndex(el => el.seller_id === data.id)
    const elem = state.sellers.items[elemIndex]
    let sellerEnabledCount = 0
    for (let item in state.sellers.items) {
      if (state.sellers.items[item].seller_enabled === 1) {
        sellerEnabledCount++
      }
    }
    if (elem.seller_enabled === 1) {
      state.sellers.items.splice(elemIndex, 1)
      state.sellers.items.splice(sellerEnabledCount - 1, 0, elem)
      elem.seller_enabled = 0 // Disable
    } else {
      state.sellers.items.splice(elemIndex, 1)
      state.sellers.items.splice(sellerEnabledCount, 0, elem)
      elem.seller_enabled = 1 // Enable
    }
  },
  SET_mutateSellers (state, filter) {
    const movedItem = state.sellers.items.splice(filter.oldIndex, 1)[0]
    state.sellers.items.splice(filter.newIndex, 0, movedItem)
    state.sellers.items.forEach((el, index) => {
      el.order = index + 1
    })
  },
  SET_loading_sellers (state, bool) {
    state.sellers.loading = bool
  },
  SET_noData_sellers (state, bool) {
    state.sellers.noData = bool
  },
  SET_trackingSellers (state, data) {
    state.trackingSellers.items = data
    state.trackingSellers.items.unshift({id: 0, name: 'Cheapest'})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/reportSettings.js